import _Box from "@material-ui/core/esm/Box";
import _Button from "@material-ui/core/esm/Button";
import _Typography from "@material-ui/core/esm/Typography";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

// material
import AddIcon from '@material-ui/icons/Add';
import { useStyles } from "./TableTopStyles";

var _ref = /*#__PURE__*/_jsx(AddIcon, {});

const TableTop = props => {
  const title = props.title,
        handleAdd = props.handleAdd,
        addTitle = props.addTitle;
  const classes = useStyles();
  return _jsx(_Box, {
    className: classes.heading,
    mb: 5
  }, void 0, title && _jsx(_Typography, {
    variant: "h5",
    gutterBottom: true
  }, void 0, title), handleAdd && _jsx(_Button, {
    variant: "contained",
    color: "primary",
    startIcon: _ref,
    className: "".concat(!title && classes.rightPosition),
    onClick: handleAdd
  }, void 0, addTitle));
};

export { TableTop };